var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cSingleBigChoice-container"},_vm._l((_vm.selectdata),function(item,index){return _c('li',{key:index,staticClass:"select-item",class:{
      'select-noactive': !item.isActive && !_vm.noChoose,
      'select-active': item.isActive && !_vm.noChoose
    },style:({ height: _vm.height ? _vm.height + 'rem' : '1rem' }),domProps:{"innerHTML":_vm._s(_vm.$sanitize(item.value))},on:{"click":function($event){return _vm.handelSelect(item)}}})}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68506279","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Select/cBigChoice.vue
// module id = null
// module chunks = 